import { cloneDeep } from 'lodash';
import request from 'superagent';
import { setLoggedIn, setLoggedOut, setSoftLoggedIn } from './is_logged_in';
import { closeModal } from './active_modal';
import { getCookie, createCookie } from '../shared/cookie.js';
import { activeStepCheckout } from './active_enroll_step';
import { clearUpgradeStatus, fireUpgradeStatus } from './upgrade_status';
const SET_CUSTOMER = 'SET_CUSTOMER';
const DETACH_CUSTOMER = 'DETACH_CUSTOMER';
const CLEAR_CART_NOTIFICATIONS = 'CLEAR_CART_NOTIFICATIONS';
const CLEAR_WISHLIST_NOTIFICATIONS = 'CLEAR_WISHLIST_NOTIFICATIONS';

const initialState = {};

export default function reducer(state = cloneDeep(initialState), action) {
  switch (action.type) {
    case SET_CUSTOMER:
      return {...action.payload};
    case DETACH_CUSTOMER:
      return {};
    case CLEAR_CART_NOTIFICATIONS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          cart: []
        }
      };
    case CLEAR_WISHLIST_NOTIFICATIONS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          wishlist: []
        }
      };
    default:
      return state;
  }
}

export function setCustomer(customer){
  return (dispatch, getState) => {
  	if(customer && Object.keys(customer).length > 0){
      let upgradingFlags = [];
      if( customer.status === 'Pending' && new Date(customer.accepted_terms_at) >  new Date() - (2 * 24 * 60 * 60 * 1000) ){
        upgradingFlags =  [ activeStepCheckout(), clearUpgradeStatus() ];
      } else if ( customer.status === "Upgrading"
        || ( getState().store.type === "Neglite" && customer.status === 'Pending' && new Date(customer.accepted_terms_at) <=  new Date() - (2 * 24 * 60 * 60 * 1000)) ) {
        upgradingFlags =  [fireUpgradeStatus()];
      }
  		return dispatch([
  			attachCustomer(customer),
  			setLoggedIn(),
        ...upgradingFlags
  		]);
    } else
  		return dispatch([
  			detachCustomer(),
  			setLoggedOut()
  		]);
  }
};

function attachCustomer(customer){
	return {
		type: SET_CUSTOMER,
		payload: customer
	}
}

export function detachCustomer(){
	return {
		type: DETACH_CUSTOMER
	}
};

export function captureLead(oLead) {
  let sSource     = 'capturedLead';

  // Get enrollCart from cookie or set to empty strings
  let aEnrollCart = getCookie('enrollCart') ? getCookie('enrollCart').split(',') : ['', ''];

  // Store email and first name as cookies
  createCookie('enrollEmail', oLead.email);
  createCookie('enrollFirstName', oLead.firstName);
  return dispatch => {
    request
      .put('/svc/misc/captureLead/' + oLead['email'])
      .query({'first_name': oLead['firstName']})
      .query({'cart1': aEnrollCart[0]})
      .query({'cart2': aEnrollCart[1]})
      .query({'source': sSource})
      .set({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
      })
      .end((err, res) => {
        if (err || res.statusCode !== 200 ) return console.log('lead capture failed', err);
        return dispatch([
          closeModal(),
          setSoftLoggedIn()
        ]);
        window.dataLayer.push({'event': 'lead'});
      });
  }
}

export function clearCartNotifications(customer) {
  return { type: CLEAR_CART_NOTIFICATIONS }
}

export function clearWishlistNotifications(customer) {
  return { type: CLEAR_WISHLIST_NOTIFICATIONS }
}


// WEBPACK FOOTER //
// ./src/modules/customer.js